import { styled } from '@mui/material/styles';
import Sticky from 'react-sticky-el';
import { StickyColumnProps } from './index';

const StyledStickyOptions = {
  shouldForwardProp: (prop: string) => !['stickyTopOffset'].includes(prop),
};

export const StyledStickyDesktopWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const StyledStickyMobileWrapper = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
}));

export const StyledSticky = styled(
  Sticky,
  StyledStickyOptions,
)<StickyColumnProps>(
  ({ stickyTopOffset }) =>
    stickyTopOffset && {
      '& > div.sticky': {
        top: `${stickyTopOffset}px !important`,
      },
    },
);

export const StyledStickyContainer = styled(
  'div',
  StyledStickyOptions,
)<{ stickyTopOffset: number }>(({ stickyTopOffset }) => ({
  height: 'calc(100vh)',
  overflow: 'scroll',
  paddingBottom: `calc(var(--payment-page-layout-sticky-column-padding) + var(--payment-page-layout-sticky-column-top-offset) + ${stickyTopOffset}px + 36px)`,
}));
